module.exports = __webpack_public_path__ + "assets/8108361706b1d9b757e4ab9ab3c4fe7d.png";